import { z } from "zod";

/**
 * A prospect can hold at most one confirmed email. When a new email is discovered for a
 * prospect that has none yet (e.g. extracted from an outreach reply), it is stored separately
 * as a *pending* (unconfirmed) email until a user explicitly confirms or rejects it.
 *
 * `PENDING_EMAIL_SOURCES` records where the pending email was found.
 */
export const PENDING_EMAIL_SOURCES = ["OUTREACH_REPLY", "PREVIOUS_PRIMARY"] as const;

export type PendingEmailSource = (typeof PENDING_EMAIL_SOURCES)[number];

export const pendingEmailSourceSchema = z.enum(PENDING_EMAIL_SOURCES);

/**
 * Actions a user can take on a prospect's pending email:
 * - `CONFIRM` makes it the prospect's primary email; any previous primary is kept as a candidate
 *   so the user can switch back.
 * - `REJECT` dismisses it.
 */
export const PENDING_EMAIL_ACTIONS = ["CONFIRM", "REJECT"] as const;

export type PendingEmailAction = (typeof PENDING_EMAIL_ACTIONS)[number];

export const pendingEmailActionSchema = z.enum(PENDING_EMAIL_ACTIONS);
